import { User, signOut } from 'firebase/auth';
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Outlet, useNavigate } from "react-router-dom";
import { auth } from './firebase';


const Layout = () => {
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user);
    });

    return unsubscribe;
  });

  async function logout() {
    await signOut(auth);
    navigate('/');
  }

    return(
      <>
        <Navbar expand="lg" className="navbar-light bg-light justify-content-between">
          <Container fluid={true}>
            <Navbar.Brand href="/listings">Broker Listings</Navbar.Brand>
            {currentUser && 
            <Nav.Link onClick={(_) => logout()}>Logout</Nav.Link>
            }
          </Container>
        </Navbar>
        <div className = "container-fluid">
            <div className = "row mt-3">
                <Outlet />
            </div>
        </div>
      </>
    )
}

export default Layout